<script setup lang="ts">
import { ConfirmModal } from '@collector/shared-ui'
</script>

<template>
  <ConfirmModal>
    <template #title>
      <div>Are you sure you want to save lineup?</div>
      <div>Number of batters is invalid.</div>
    </template>
  </ConfirmModal>
</template>
